// packages
import React from "react"
import PropTypes from "prop-types"
// Utils
import { getPresetSuffix } from "lib/utils/preset-util"

// Component
import ProductName from "components/Stacker/components/ProductName/ProductName"
import ProductOverview from "components/Stacker/components/ProductOverview/ProductOverview"
import ViewDetailsLink from "components/Stacker/components/ViewDetailsLink/ViewDetailsLink"
// Style
import "./ProductRefiner.scss"
import { useSelector } from "react-redux"

function ProductRefiner({
  isCsAgent,
  productType,
  refinerId,
  shopTheLookURL,
  productDetails,
  refiner,
}) {
  const { cartMetaData } = useSelector((state) => {
    return {
      cartMetaData: state.cart.meta,
      isReviewing: state.stacker.isReviewing,
    }
  })

  const {
    selectedSize = null,
    selectedVariant,
    selectedVariantIndex,
    selectedVariant: { imageURL, productName },
  } = refiner
  const {
    data: {
      products,
      products: {
        isProductConfigurable,
        isEngagementProduct,
        productId,
        url,
        cropQuadrant,
      },
      sizeChart,
      metals,
    },
    isGiftCard,
    priceInventory: { priceList, stock: { stockLevel } = {} } = {},
    priceInventory,
    sizeSelectionError,
    selectedAmount,
  } = productDetails

  if (!selectedVariant) return null

  const refinedSize = refiner.selectedSize || selectedSize
  const price = selectedSize ? selectedSize.price : selectedVariant.price

  const priceData =
    priceList !== undefined
      ? priceList["de.hybris.platform.commercefacades.product.data.PriceData"]
      : []

  const isPreorder =
    priceInventory && priceInventory.stock.preOrderFlag === "true"
  const availabilityTextKey =
    stockLevel !== "0" && !isPreorder ? "inStocktext" : "outOfStockText"

  const imagePreset = getPresetSuffix(cropQuadrant, "TILE_DESKTOP")
  return (
    <div className="product-refiner">
      <div>
        <img
          className="product-image"
          src={`${imageURL}${imagePreset}`}
          alt={`shop the look ${productName}`}
        />
      </div>
      <div className="product-details">
        <ProductName
          availabilityTextKey={availabilityTextKey}
          discountedPrice={price.discountedPrice || null}
          displayAffirm={false}
          formattedValue={price.formattedValue}
          isCsAgent={isCsAgent}
          isEngagementProduct={isEngagementProduct}
          isGiftCard={isGiftCard}
          isShopTheLookPage
          priceList={priceData}
          productName={productName}
          showAvailability
        />
        <ProductOverview
          cartMetaData={cartMetaData}
          displayAddtoBag={!isProductConfigurable}
          isGiftCard={isGiftCard}
          isPDPPage={false}
          isStackerPage
          isQuickView={false}
          pid={productId}
          priceInventory={priceInventory}
          productDetails={products}
          productMetals={metals}
          productSizeChart={sizeChart}
          productType={productType}
          refinerId={refinerId}
          selectedAmount={selectedAmount}
          selectedSize={refinedSize}
          selectedVariant={selectedVariant}
          selectedVariantIndex={selectedVariantIndex}
          shopTheLookURL={shopTheLookURL}
          sizeSelectionError={sizeSelectionError}
        />
        {/*<ViewDetailsLink url={url} pid={detailsId} />*/}
      </div>
    </div>
  )
}

ProductRefiner.propTypes = {
  isCsAgent: PropTypes.bool,
  productType: PropTypes.string,
  refinerId: PropTypes.string.isRequired,
  shopTheLookURL: PropTypes.string,
  productDetails: PropTypes.object,
  refiner: PropTypes.object,
}

export default ProductRefiner
